import { render } from "./HistoryItemCard.vue?vue&type=template&id=de476dd4"
import script from "./HistoryItemCard.vue?vue&type=script&lang=js"
export * from "./HistoryItemCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__